package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.repository.PostRepository
import com.example.readingnotes.util.Result

class LoadPostListWithPaginationUseCase(
    private val postRepository: PostRepository,
) {
    suspend operator fun invoke(
        page: Int = 1,
        pageSize: Int = 20,
    ): Result<com.example.readingnotes.domain.repository.PaginatedPosts> =
        postRepository.getPostsWithPagination(page, pageSize)
}
